import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../Api";
import Section from "../../parts/Section";
import { brlToInt, intToBrl } from "../../utils";
import EquipmentsForm from "./Form";
import { Equipment, EquipmentUI, UIValue } from "../../types";

const EquipmentsUpdate = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [equipment, setEquipment] = useState<EquipmentUI | null>(null);
  const [error, setError] = useState(false);

  const updateEquipment = (key: string) => (value: UIValue) => {
    setEquipment((equipment) => ({ ...equipment!, [key]: value }));
  };

  useEffect(() => {
    Api.equipmentsGetByUuid(uuid!).then((equipment: Equipment) =>
      setEquipment({
        ...equipment,
        price: intToBrl(equipment.price),
        rent: intToBrl(equipment.rent),
      })
    );
  }, [uuid]);

  const save = async () => {
    const payload = {
      ...equipment!,
      price: brlToInt(equipment!.price),
      rent: brlToInt(equipment!.rent),
    };
    const result = await Api.equipmentsUpdate(uuid!, payload);
    result.success ? navigate("/equipamentos") : setError(true);
  };

  return (
    <Section className="p-4 pb-32">
      {!!equipment && (
        <EquipmentsForm
          equipment={equipment}
          onChange={updateEquipment}
          onSubmit={save}
          error={error}
        />
      )}
    </Section>
  );
};

export default EquipmentsUpdate;
